import { render, staticRenderFns } from "./ClassPage.vue?vue&type=template&id=d7aec29e&scoped=true&"
import script from "./ClassPage.vue?vue&type=script&lang=js&"
export * from "./ClassPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7aec29e",
  null
  
)

export default component.exports